import { userCookieStorage } from 'core/authentification';
import { CLOSE_REQUEST_STATUS, closedRequestsPossibleStatus, creatorFilterItems, INPROGRESS_REQUEST_STATUS, RANGE_DATE_FORMAT, REQUESTED_ON_DATE_FORMAT, statusFilterItems } from '../consts';
import moment from 'moment';
import { MultiSelectItemProps } from '@placer-ui/components';

type MultiSelectTogglerOptions = 'checkbox' | 'partial-checkbox' | 'switch';
type ParsedEntry = {
  headline: string;
  value: string;
};

export const convertXtraRequestStatus = (status: string) => {
    if (closedRequestsPossibleStatus.includes(status)) {
        return CLOSE_REQUEST_STATUS;
    } else {
        return INPROGRESS_REQUEST_STATUS;
    }
};

export const getRequestedByUser = (userAccounts: Record<string, string>, requestedBy: string | undefined, requestorEmail: string | undefined) => {
    if (!requestedBy && !requestorEmail) {
        return userCookieStorage.user?.email || '';
    }
    return userAccounts[requestedBy as string] || requestorEmail || '';
};

export const getUserReportDates = (reportDates: {from: string; to: string}) => {
    return `${moment(reportDates.from).format(
                                REQUESTED_ON_DATE_FORMAT,
                            )} - ${moment(reportDates.to).format(RANGE_DATE_FORMAT)}`;
};

export const getUserReportRequestedOnDates = (requestedOn: string) => {
    return moment(requestedOn).format(RANGE_DATE_FORMAT);
};

export const parseHtmlComment = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const paragraphs = Array.from(doc.querySelectorAll('p'));

  let lastHeadline = '';
  const result: ParsedEntry[] = [];

  for (const p of paragraphs) {
    const bold = p.querySelector('b');
    const hasBold = !!bold;
    const headlineText = bold?.textContent?.trim().replace(/:$/, '') || '';

    if (bold) bold.remove(); // remove <b> so we can get clean value
    const value = p.textContent?.trim() || '';

    if (hasBold && value) {
      // <b> and value in same <p>
      lastHeadline = headlineText;
      result.push({ headline: lastHeadline, value });
    } else if (hasBold && !value) {
      // <b> only, no value yet
      lastHeadline = headlineText;
    } else if (!hasBold && value) {
      // value only, use last headline
      result.push({ headline: lastHeadline, value });
    } else if (hasBold && value === '') {
      // headline with empty value (like Notes)
      lastHeadline = headlineText;
      result.push({ headline: lastHeadline, value: '' });
    }
  }

  return result;
};

const hasSelectionChanged = (defaultItems: MultiSelectItemProps[], currentSelectedItems: MultiSelectItemProps[]) => {
    const mapB = new Map(currentSelectedItems.map(item => [item.value, item.isSelected]));

    return defaultItems.some(item => mapB.get(item.value) !== item.isSelected);
};

export const areXtraRequestsFiltered = (statusesCount: MultiSelectItemProps[],
    typesCount: MultiSelectItemProps[],
    isUnread: boolean) => {
  if (isUnread) return true;

  return (
    hasSelectionChanged(statusFilterItems as MultiSelectItemProps[], statusesCount) ||
    hasSelectionChanged(creatorFilterItems as MultiSelectItemProps[], typesCount)
  );
};

export const createAccountMembersItems = (
  accountMembers: {username: string; id: string}[],
) => {

  return accountMembers?.map((member) => {
    return {
        value: member.id,
        label: member.username,
        testId: 'xtra-member-item',
        multi: 'checkbox' as MultiSelectTogglerOptions,
        isSelected: false,
    };
  });
};

